import { useState, useEffect } from 'react';
import { onValue, DataSnapshot } from 'firebase/database';
import { ProductDetails } from '../models/product';
import { firebaseProductsToArray } from '../utils/data';
import logger from '../utils/logger';
import { getProductsRef } from '../utils/firebase';

export const useProducts = () => {
  const [products, setProducts] = useState<ProductDetails[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [productsError, setProductsError] = useState<string | null>(null);

  useEffect(() => {
    setIsLoading(true);
    setProductsError(null);
    logger.info('products.fetch.start');

    const reference = getProductsRef();
    const unsubscribe = onValue(reference, (snapshot: DataSnapshot) => {
      try {
        const data = snapshot.exists() ? snapshot.val() : {};
        const productArray = firebaseProductsToArray(data);
        setProducts(productArray);
        setProductsError(null);
        setIsLoading(false);
        logger.info('products.fetch.success', { count: productArray.length });
      } catch (error) {
        logger.error('products.fetch.failed', error);
        setProducts([]);
        setProductsError('Unable to load products. Please refresh the page.');
        setIsLoading(false);
      }
    }, (error) => {
      logger.error('products.fetch.listener.error', error);
      setProducts([]);
      setProductsError('Unable to load products. Please refresh the page.');
      setIsLoading(false);
    });

    return () => {
      if (typeof unsubscribe === 'function') unsubscribe();
    };
  }, []);

  return { products, isLoading, productsError };
};
